<script>
	import {getText} from '../../../../share/utils';
</script>

<div>
	<div class="flex structure marginbox_left">
		<div class="flex col structure-1">
			<div class="flex element">
				<div class="content block-to-flex">
					<h1 class="left">{getText("20.02.01_h2")}</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="flex structure marginbox_left">
		<div class="flex col structure-2">
			<div class="flex element">
				<img loading="lazy" alt="AES HUB - housebuilder awards 2024"
					 src="./../img/20.AES_HUB/02.intro/housebuilder_award.webp">
			</div>
		</div>
		<div class="flex col structure-3">
			<div class="flex element">
				<div class="content">
					<p class="caption">{getText("20.02.02_caption")}</p>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";

	.flex {
		display: flex;
		box-sizing: border-box;
		flex-direction: column;

		@include for-tablet-landscape-up {
			flex-direction: unset;
		}

		&:last-of-type {
			gap: px-to-rem(45);
		}
	}

	.row {
		flex-flow: row wrap;
	}

	.col {
		flex-flow: column wrap;
	}

	.element {
		min-width: 100px;
		width: 100%;

		&.wrap {
			flex-wrap: wrap;
		}
	}

	.content {
		flex: 1 100%;
	}

	.structure {
		margin-bottom: $spacing-mobile-half;
		gap: $media-gap;
	}

	.structure-1 {
		flex-shrink: 1;
		width: auto;
		margin: $spacing-mobile;

		@include for-tablet-portrait-up {
			width: 70%;
			margin: 0;
			padding: 0 $media-gap 0 0;
		}

		img {
			margin-bottom: $spacing-mobile*.5;
		}

		.block-to-flex {
			display: block;

			@include for-tablet-portrait-up {
				display: flex;
			}
		}

		h1 {
			margin: calc(var(--spacing-mobile) * 2) 0 var(--spacing-mobile);
		}
	}

	.structure-2 {
		flex-shrink: 0;
		width: fit-content;

		@include for-tablet-portrait-up {
			margin: 0;
		}

		@include for-desktop-up {
			justify-content: flex-start;
		}

		.element {
			height: auto;
			align-items: center;

			img {
				height: fit-content;
			}
		}

		.commercial {
			width: 100%;
			height: unset;
		}

		.rec {
			max-width: unset;
			max-height: unset;
			position: relative;
		}
	}

	.structure-3 {
		width: calc(939 * 100% / 1491);
		margin: 0 1.9em 1.9em 1.9em;
		flex-wrap: wrap;

		@include for-tablet-portrait-up {
			margin: 0;
			padding: 0;
		}

		@include for-desktop-up {
			flex-shrink: 0;
		}

		.headline {
			width: 35%;
			padding-right: $media-gap;
			word-break: break-word;
			hyphens: auto;
			display: flex;
			flex-direction: row-reverse;

			@include for-tablet-portrait-up {
				width: 40%;
				text-align: right;
				padding-left: $spacing-mobile;
			}
		}

		p {
			@include font-px-to-rem(35, 55, 300);
		}

		:global(.see_more_button) {
			margin-left: 35%;

			@include for-tablet-portrait-up {
				margin-left: 0;
				padding-right: $spacing-mobile;
			}
		}
	}

	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	h2 {
		margin-bottom: $spacing-mobile-one-third;
	}

	p:first-of-type {
		margin-bottom: $media-gap;
	}

	.rec {
		max-width: 720px;
		max-height: 480px;
		margin: 0 0 $media-gap 0;
		flex-grow: 1;

		@include for-tablet-portrait-up {
			margin: 0 0 $media-gap 0;
		}

		.commercial {
			overflow: hidden;
		}

		.container-overlay {
			position: absolute;
			width: 80%;
			height: fit-content;
			left: 10%;
			top: 18%;

			@include for-desktop-up {
				top: 11%;
			}
		}

		.scaled-iframe {
			width: 720px;
			height: 480px;
			border: 0;

			zoom: 1;
			transform: scale(1);
			transform-origin: 0 0;
			position: absolute;
			left: 0;
			top: 0;

			// 0.8 as equivalent to 80% (see above)
			scale: calc(var(--scale) * 0.8) !important;
			height: calc(var(--origHeight)) !important;
			width: calc(var(--origWidth)) !important;
		}
	}

	.playing .container-overlay > img {
		opacity: 0;
	}

	.rec iframe {
		width: 100%;
		height: 100%;

		position: absolute;
		left: 0;
	}

	iframe {
		border: none;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(iframe[loaded]) {
		background-image: none;
	}

	:global(.align-right) {
		float: right;
		text-align: right;

		:global(a) {
			padding-right: 0;
		}
	}

	:global(.w_100_60) {
		@include for-tablet-portrait-up {
			width: 60%;
		}
	}

	:global(.w_20) {
		@include for-tablet-portrait-up {
			width: 20%;
		}
	}
</style>
